<template>
  <div class="card no-shadow">
   <div class="card-content p-x-0">
      <div class="content">

        <div class="columns margin-bottom-20">

          <div class="column is-paddingless margin-right-30 is-4">
            <search v-on:search="search($event)"
                    placeholder="Search by email address"
                    :addMarginLeft=false
                    desktopCss="is-12-tablet is-11-desktop"
                    class="is-paddingless is-marginless"></search>
          </div>

          <div class="column is-paddingless margin-right-30 is-4">

              <div class="column is-paddingless is-marginless is-hidden-mobile">
                  <div class="columns">
                      <div class="column is-paddingless is-marginless">
                          <input
                              class="input is-size-6 input-biz-search"
                              type="text"
                              v-model="business_name"
                              @keyup="orgLookup()"
                              :placeholder="`Enter a Business`"
                              autocomplete="off"
                          />
                      </div>

                      <div class="column is-paddingless is-marginless is-narrow">
                          <button class="button-search" @click.prevent="searchOrg()">
                            <span class="icon"><i class="fas fa-search"></i></span>
                          </button>
                      </div>
                  </div>
              </div>

              <!-- orgs lookup dropdown -->
              <div v-if="orgsFound">
                <div class="dropdown" :class="showOrgLookDropdown">
                  <div class="dropdown-menu" role="menu">
                    <div
                        v-if="businesses.length > 0"
                        class="dropdown-content is-paddingless"
                        @mouseleave.self="hideBusinessAutoComplete"
                    >
                      <a
                          v-for="business in businesses"
                          @click.prevent="selectOrg(business)"
                          href="#"
                          :ref="`${business.id}`"
                          class="dropdown-item has-text-left"
                      >{{ business.name }}
                        <span v-if="business.subscription" data-v-1789c32a="" class="icon is-right green" style=""><i data-v-1789c32a="" class="fas fa-check"></i></span>
                      </a
                      >
                    </div>
                  </div>
                </div>
              </div>

            </div>
        </div>

        <p v-if="!fetching_data" v-resultsCount="[total_records, all_records]"></p>

        <div class="column is-paddingless">
          <table class="table is-size-7-touch is-marginless is-fullwidth">
            <thead>
            <tr>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">First name</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Last name</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Email address</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Linked Business</td>
            </tr>
            </thead>
            <tbody>
            <tr v-if="(is_loading && items.length === 0) || (!fetching_data && items.length === 0)">
              <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey"
                  colspan="8">
                <p class="has-text-centered is-padded-20">No results found</p>
              </td>
            </tr>
            <tr class="margin-bottom-20" v-for="(item, index) in items" v-if="items.length > 0"
            @click="gotoBizUserDetails(item.id)">
              <td class="is-narrow-mobile is-desktop">{{item.first_name}}</td>
              <td class="is-narrow-mobile is-desktop">{{item.last_name}}</td>
              <td class="is-narrow-mobile is-desktop">{{item.email}}</td>
              <td class="is-narrow-mobile is-desktop">

                <span v-if="item.business_account_invite.length === 0">No business link</span>

                <router-link
                    v-if="item.business_account_invite.length === 1 && item.business_account_invite[0].org !== null"
                    :to="'/business/'+ item.business_account_invite[0].org.slug + '/reviews'"
                    target="_blank">
                  {{ item.business_account_invite[0].org.name}}
                </router-link>

                <span v-if="item.business_account_invite.length === 2">

                  <span v-if="item.business_account_invite[0].org !== null && item.business_account_invite[1].org !== null">
                    <router-link target="_blank" :to="'/business/'+ item.business_account_invite[0].org.slug + '/reviews'">{{ item.business_account_invite[0].org.name}}</router-link>,
                    <router-link target="_blank" :to="'/business/'+ item.business_account_invite[1].org.slug + '/reviews'">{{ item.business_account_invite[1].org.name}}</router-link>
                  </span>

                  <span v-if="item.business_account_invite[0].org === null || item.business_account_invite[1].org === null">
                    <router-link v-if="item.business_account_invite[0].org !== null" target="_blank" :to="'/business/'+ item.business_account_invite[0].org.slug + '/reviews'">{{ item.business_account_invite[0].org.name}}</router-link>
                    <router-link v-if="item.business_account_invite[1].org !== null" target="_blank" :to="'/business/'+ item.business_account_invite[1].org.slug + '/reviews'">{{ item.business_account_invite[1].org.name}}</router-link>
                  </span>


                </span>

                <a v-if="item.business_account_invite.length > 2"
                   @click="getBizUserOtherProfiles(item.email, $event)">{{ item.business_account_invite.length + ' Businesses'}}</a>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
      <paginator :dataSet="dataSet" @changed="getBizUsersListings"></paginator>
    </div>
  </div>


</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'
  import qs from 'qs'
  import Paginator from './../../components/Paginator.vue'
  import misc from '../../mixins/misc.js'
  import Search from './../../components/Search'
  import ApiResource from './../../api/ApiResource'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Biz users'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Users'
      })
    },
    components: {Paginator, Search},
    mixins: [misc],
    data () {
      return {
        no_of_items: 0,
        is_loading: true,
        fetching_data: false,
        items: [],
        dataSet: {},
        page: undefined,
        total_records: 0,
        keyword_search: undefined,
        keyword_string: undefined,

        business_name: undefined,
        business_id: undefined,
        businesses: [],
        ajax_lookup: true,
        show_dropdown: false,
        all_records: -1
      }
    },
    created () {
      if (this.$route.query.keyword) {
          this.keyword_search = qs.stringify({keyword: this.$route.query.keyword})
          this.keyword_string = this.$route.query.keyword
      }
      if (this.$route.query.bizName) {
          this.business_name = this.$route.query.bizName
      }
      this.getBizUsersListings(null)
    },
    computed: {
      showOrgLookDropdown () {
        if (this.on_blur_close) {
          return ''
        }
        if ((this.orgsFound) && !this.on_blur_close) {
          return 'is-active'
        }
      }
    },
    methods: {
      /**
       * Goes to business detail page
       * @param {object} id Biz User ID
       * @return {void}
       */
      gotoBizUserDetails (id) {
        let searchedStrings = {
            keyword: this.keyword_string,
            bizName: this.business_name,
            page: this.page
        }
        let searchKeyword = qs.stringify(searchedStrings)
        this.$router.push(`/bizuser-detail/${id}?${searchKeyword}`)
      },
      /**
       * Make request to api to get reported reviews listings
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getBizUsersListings (page) {
        this.page = page || 1
        this.fetching_data = true
        axios.get(this.url(page, this.keyword_search))
          .then((response) => {
            this.refresh(response)
            response.data.data = undefined
            this.is_loading = false
            this.fetching_data = false
          })
          .catch(() => {
            flash('You are not authorized to view this resource.', 'is-danger')
            this.is_loading = false
            this.fetching_data = false
          })
      },
      /**
       * Search keyword/term to search for
       * @param {string} search search term/keyword
       * @returns {void}
       */
      search (search) {
        this.keyword_search = qs.stringify({keyword: search})
        this.keyword_string = search
        this.getBizUsersListings(1)
      },
      orgLookup () {
        this.business_id = undefined
        this.on_blur_close = false
        if (this.business_name.length < 3) {
          this.businesses = []
          this.show_dropdown = false
        } else {
          this.is_loading = true
          let keyword = encodeURIComponent(this.business_name)
          new ApiResource({})
            .send(`/search/business?name=${keyword}`, {}, 'get')
            .then(businesses => {
              if (businesses.length === 0) {
                this.businesses = []
                this.show_dropdown = false
                this.business_available = true
                this.drop_down_opened = false
                this.is_loading = false
                closeFlash()
              } else {
                this.drop_down_opened = true
                this.businesses = businesses
                this.is_loading = false
              }
            })
            .catch(() => {
              flash(
                `Error retrieving possible businesses! Contact the System's Administrator.`,
                `is-danger`
              )
              this.is_loading = false
              this.drop_down_opened = false
            })
        }
      },
      /**
       * On click listener for when user selects a business from list of suggestions presented from api
       * @returns {null}
       * @param {business} business selected by user
       */
      selectOrg (business) {
        this.business_name = business.name
        this.business_slug = business.slug
        this.business_id = business.id
        this.status = business.status
        this.businesses = []

        this.business_available = true
        closeFlash()
        this.drop_down_opened = false
      },
      searchOrg () {
        this.getBizUsersListings(1)
      },
      hideBusinessAutoComplete () {
        try {
          this.drop_down_opened = true
          this.on_blur_close = true
          const parent = this
          parent.business_available = false
          this.businesses.forEach(business => {
            let inlist = false
            if (
              this.business_name.toLowerCase() ===
              business.name.toLowerCase() &&
              !inlist
            ) {
              if (business.status !== 'ACTIVE' && !inlist) {
                inlist = true
                parent.business_available = true
                parent.drop_down_opened = false
                closeFlash()
                throw new Exception('available')
              }
            }
            if (
              this.business_name.toLowerCase() !==
              business.name.toLowerCase() &&
              !inlist
            ) {
              inlist = true
              parent.business_available = true
              parent.drop_down_opened = false
              closeFlash()
            }
          })
        } catch (e) {}
      },
      orgsFound () {
        return this.businesses.length > 0
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @param {string} keyword search keyword
       * @return {string}
       */
      url (page, keyword) {
        let query = location.search.match(/page=(\d+)/)
        if (!page) {
          page = query ? query[1] : 1
        }
        if (keyword !== undefined && this.keyword_string !== 0) {
          page += `&${keyword}`
        }
        if (this.business_id !== '' && this.business_id !== undefined) {
          page += `&${qs.stringify({bizId: this.business_id})}`
        }
        return `/users/biz-users/?page=${page}`
      },
      /**
       * get User's other business profiles
       * @param {string} email the email address of business user
       * @param {object} event Event Object
       * @return {void}
       */
      getBizUserOtherProfiles (email, event) {
        event.stopPropagation()
        axios.get(`/business/${email}/other-profiles/`)
          .then((response) => {
            let body = '<ul style="font-weight: normal;">'
            response.data.forEach((org) => {
              body += `<li><a target="_blank" href="/business/${org.business_slug}/billing">${org.business_name}</a>  - ${org.role_name}</li>`
            })
            body += '</ul>'
            let options = {
              'title': '',
              'small_title': `<strong>${email}</strong> is also linked to these businesses`,
              'body': body,
              'show_btns': false
            }
            modal(options)
          })
          .catch(() => {
          })
      }
    }
  }
</script>

<style scoped>
  .table td, .table th {
    border: none;
  }

  .table > tbody > tr {
    background-color: #f5f5f5 !important;
    margin-bottom: 10px;
  }

  .table > tbody > td {
    margin-bottom: 20px;
  }

  tr {
    cursor: pointer;
  }

  .input-biz-search {
      border: 1px solid #8a8c91;
      border-right: 0;
      font-size: .85em !important;
      padding: 17px !important;
  }

  .is-on-grey-strap {
      background: transparent !important;
      border: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/users/BusinessUsersListing.vue